module.exports = __webpack_public_path__ + "static/media/Serendipity_Wide.9e11fe3d.otf";


/*****************
 ** WEBPACK FOOTER
 ** ./public/fonts/Serendipity_Wide.otf
 ** module id = 1892
 ** module chunks = 50
 **/